/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Stronger Memory API
 * Lean companion API. OnEarly Core is the system of record.
 * OpenAPI spec version: 0.0.1
 */
import * as zod from 'zod';

export const ErrorResponse = zod.object({
  error: zod.literal(true),
  code: zod.string(),
  message: zod.string(),
});

export type ErrorResponse = zod.input<typeof ErrorResponse>;
export type ErrorResponseOutput = zod.output<typeof ErrorResponse>;
